import React from "react";
import DatePicker from "./DatePicker";
import mut from "../hooks/mut";
import Info from "./Info";

/**
 * 
 * @param {string} dateOfBirth date of birth of the student 
 * @param {boolean} noDate Don't show date of birth
 * @returns 
 */


export default function DateOfBirth({ dateOfBirth, noDate,setStudent,student }) {
  if (!dateOfBirth)
    return (
      <div style={{ width: 100 }}>
        <DatePicker value="" setValue={(dateOfBirth) => {
          setStudent(prev => ({ ...prev, dateOfBirth }))
          mut("post", `/students/${student._id}`, { dateOfBirth })
        }} />
      </div>
    );

  return <Info title="Năm sinh" body={new Date(dateOfBirth).fDate()} />

   
  
  
}
